import Units from "../../../utils/Units";

let gridColor = "rgba(0, 0, 0, 0.1)";
let tickFontSize = 10;
let Seconds = {
    id: "seconds",
    type: 'category',
    distribution: 'series',
    gridLines: {
        color: gridColor,
        zeroLineColor: "rgba(0, 0, 0, 0)"
    },
    ticks: {
        fontSize: tickFontSize,

        callback: (value, index, values) => {
            return value;
        }
    }
};

export default Seconds;



// WEBPACK FOOTER //
// ./src/components/chart/axes/Seconds.js